export default __webpack_public_path__ + "static/media/Inhaler.256.874d4625.png";